import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Container,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
  Col,
  Table,
} from "reactstrap";
import defaultProfileImg from "../../assets/img/brand/goodybuddy_short.png"; // Placeholder profile image
import adminModel from "models/admin.model";
import { helper } from "lib/helper";
import Loader from "components/loader/Loader";
import AddButton from "components/Button/AddButton";
import BackButton from "components/Button/BackButton";

const features = [
  "User",
  "Listings",
  "Bookings",
  "Sub-Admin",
  "Terms and Conditions",
  "Feedback",
  "Support",
  "Experience Category",
];



const AddEditSubAdmin = () => {
  const [subAdmin, setSubAdmin] = useState({
   user : {
    firstName: "",
    lastName: "",
    mobileNo: "",
    email: "",
    type: "",
    newPassword: "",
    oldPassword: "",
    confirmPassword: "",
    profileImage: defaultProfileImg,
   },
    permissions: {
      user: { view : false , add: false, edit: false, delete: false },
      listing: { view : false , add: false, edit: false, delete: false },
      bookings: { view : false , add: false, edit: false, delete: false },
      subAdmin: { view : false , add: false, edit: false, delete: false },
      terms: { view : false , add: false, edit: false, delete: false },
      feedback: { view : false , add: false, edit: false, delete: false },
      support: { view : false , add: false, edit: false, delete: false },
      experienceCategory: { view : false , add: false, edit: false, delete: false },
    },
  });

  const [loading, setLoading] = useState(false);
  const { id } = useParams(); 
  const navigate = useNavigate();
  const [file , setFile] = useState(null);

  useEffect(() => {
    if (id) {
      // Edit mode: find sub-admin by id
      setLoading(true);
      adminModel.getAllSubAdmins(id).then(res => {
        console.log(res)
        const data = res.subAdmins[0];
        setSubAdmin({...data, user : {...data.user, profileImage : data.user.profileImage || defaultProfileImg , oldPassword : '' , newPassword : '' , confirmPassword : ''}});
        setLoading(false);
      }).catch(err => {
        console.log(err)
        helper.sweetalert.error("Something went wrong, Please try again later!");
      })
    }
  }, [id]);

  // Handle form input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setSubAdmin((prevSubAdmin) => ({
      ...prevSubAdmin,
      [name]: value,
    }));
  };

  // Handle permission checkbox changes
  const handlePermissionChange = (feature, action) => {
    setSubAdmin((prevSubAdmin) => ({
      ...prevSubAdmin,
      permissions: {
        ...prevSubAdmin.permissions,
        [feature]: {
          ...prevSubAdmin.permissions[feature],
          [action]: !prevSubAdmin.permissions[feature][action],
        },
      },
    }));
  };

  // Handle form submission
  const handleSubmit = (e) => {
    setLoading(true);
    e.preventDefault();
    const formData = new FormData();
    Object.entries(subAdmin.user).forEach(([key, value]) => {
      if(subAdmin.user[key].toString() === '') return;
      formData.append(key, value);
    });

    formData.delete('profileImage')

    formData.append("permissions", JSON.stringify(subAdmin.permissions));

    if (file) {
      formData.append("image", file);
    }

    if(subAdmin.user.newPassword !== subAdmin.user.confirmPassword){
      helper.sweetalert.toast("Password and Confirm Password does not match!" , 'error');
      return;
    }

    console.log(subAdmin.user.oldPassword)

    if(subAdmin.user.oldPassword !== '' && subAdmin.user.newPassword === subAdmin.user.oldPassword){
      helper.sweetalert.toast("New Password and Old Password should not be same!" , 'error');
      return;
    }
    if (id) {
      adminModel
        .updateSubAdmin(id, formData)
        .then(() => {
          helper.sweetalert.toast("Sub-admin updated successfully!");
          navigate("/admin/sub-admin/all");
          setLoading(false);
        })
        .catch((err) => {
          console.log(err);
          helper.sweetalert.toast("Something went wrong, Please try again later!" , 'error');
          setLoading(false);
          navigate("/admin/sub-admin/all");
        });
    } else {
      adminModel
        .createSubAdmin(formData)
        .then(() => {
          helper.sweetalert.toast("Sub-admin added successfully!");
          navigate("/admin/sub-admin/all");
          setLoading(false);
        })
        .catch((err) => {
          console.log(err);
          helper.sweetalert.toast("Something went wrong, Please try again later!" , 'error');
          setLoading(false);
          navigate("/admin/sub-admin/all");
        });
    }
  };


  const handleFindSubAdminPrev = (feature) => {

    switch (feature) {
        case "User":
            return 'user';
        case "Listings":
            return 'listing';
        case "Bookings":
            return 'bookings';
        case "Sub-Admin":
            return 'subAdmin';
        case "Terms and Conditions":
            return 'terms';
        case "Feedback":
            return 'feedback';
        case "Support":
            return 'support';
        case "Experience Category":
            return 'experienceCategory';
    }

  }



  return loading ? <Loader/> :  (
    <Container className="pt-7">
      <Row>
        <Col lg="12" className="mx-auto">
          <Card className="shadow">
            <CardHeader className="border-0">
              <h3 className="mb-0">{id ? "Edit Sub-Admin" : "Add Sub-Admin"}</h3>
            </CardHeader>
            <CardBody>
              <Form onSubmit={handleSubmit}>
                <Row>
                  <Col md="4">
                  <FormGroup>
                  <Label for="name">First Name</Label>
                  <Input
                    type="text"
                    id="name"
                    name="name"
                    value={subAdmin?.user?.firstName}
                    onChange={(e) => {setSubAdmin((prevSubAdmin) => ({...prevSubAdmin, user : {...prevSubAdmin.user , firstName : e.target.value}}))}}
                    placeholder="Enter sub-admin name"
                    required
                  />
                </FormGroup>
                  </Col>
                  <Col md="4">
                  <FormGroup>
                  <Label for="name">Last Name</Label>
                  <Input
                    type="text"
                    id="name"
                    name="name"
                    value={subAdmin?.user?.lastName}
                    onChange={(e) => {setSubAdmin((prevSubAdmin) => ({...prevSubAdmin, user : {...prevSubAdmin.user , lastName : e.target.value}}))}}
                    placeholder="Enter sub-admin name"
                    required
                  />
                </FormGroup>     
                  </Col>
                  <Col md="4">  
                    <FormGroup>
                      <Label for="mobile">Mobile</Label>
                      <Input
                        type="text"
                        id="mobile"
                        name="mobile"
                        value={subAdmin?.user?.mobileNo}
                        onChange={(e) => {setSubAdmin((prevSubAdmin) => ({...prevSubAdmin, user : {...prevSubAdmin.user , mobileNo : e.target.value}}))}}
                        placeholder="Enter mobile number"
                        required
                      />
                    </FormGroup>
                  </Col>
                </Row>

                <Row>
                  <Col md="4">
                  <FormGroup>
                  <Label for="email">Email</Label>
                  <Input
                    type="email"
                    id="email"
                    name="email"
                    value={subAdmin?.user?.email}
                    onChange={(e) => {setSubAdmin((prevSubAdmin) => ({...prevSubAdmin, user : {...prevSubAdmin.user , email : e.target.value}}))}}
                    placeholder="Enter email address"
                    required
                  />
                </FormGroup>
                  </Col>
                  <Col md="4">
                  <FormGroup>
                  <Label for="designation">Designation</Label>
                  <Input
                    type="text"
                    id="designation"
                    name="designation"
                    value={subAdmin?.user?.type}
                    onChange={(e) => {setSubAdmin((prevSubAdmin) => ({...prevSubAdmin, user : {...prevSubAdmin.user , type : e.target.value}}))}}
                    placeholder="Enter designation"
                    required
                  />
                </FormGroup>
                  </Col>

                  <FormGroup style={{marginLeft : '18px'}}>
                    
                    <Label for="profilePicture">Profile Picture</Label>
                    <Input

                      type="file"
                      id="profilePicture"
                      name="profilePicture"
                      accept="image/*"
                      onChange={(e) => {
                        const file = e.target.files[0];
                        setFile(file);
                        if (file) {
                          const reader = new FileReader();
                          reader.onloadend = () => {
                            setSubAdmin((prevSubAdmin) => ({
                              ...prevSubAdmin,
                              user : {...prevSubAdmin.user , profileImage : reader.result},
                            }));
                          };
                          reader.readAsDataURL(file);
                        }
                      }}
                      
                    />
                    <img
                      src={subAdmin?.user?.profileImage}
                      alt="Profile Preview"
                      style={{
                        width: "100px",
                        height: "100px",
                        borderRadius: "50%",
                        marginTop: "10px",
                      }}
                    />
                  </FormGroup>

                </Row>
                
               <Row>
               {id && <Col md='4'>
                <FormGroup>
                  <Label for="designation">Previous Password</Label>
                  <Input
                    type="text"
                    id="previousPassword"
                    name="previousPassword"
                    value={subAdmin?.user?.oldPassword || ''}
                    onChange={(e) => {setSubAdmin((prevSubAdmin) => ({...prevSubAdmin, user : {...prevSubAdmin.user , oldPassword : e.target.value}}))}}
                    placeholder="Enter Previous Password"
           
                  />
                </FormGroup>
                </Col>}
                <Col md='4'>
                      
                <FormGroup>
                  <Label for="designation">New Password</Label>
                  <Input
                    type="text"
                    id="newPassword"
                    name="newPassword"
                    value={subAdmin?.user?.newPassword}
                    onChange={(e) => {setSubAdmin((prevSubAdmin) => ({...prevSubAdmin, user : {...prevSubAdmin.user , newPassword : e.target.value}}))}}
                    placeholder="Enter New Password"
              
                  />
                </FormGroup>
                </Col>
                <Col md='4'>
                <FormGroup>
                  <Label for="designation">Confirm Password</Label>
                  <Input
                    type="text"
                    id="confirmPassword"
                    name="confirmPassword"
                    value={subAdmin?.user?.confirmPassword || ''}
                    onChange={(e) => {setSubAdmin((prevSubAdmin) => ({...prevSubAdmin, user : {...prevSubAdmin.user , confirmPassword : e.target.value}}))}}
                    placeholder="Enter Confirm Password"

                  />
                </FormGroup>
                </Col>
               </Row>
                
                 
                
                {/* Permissions Table */}
                <h4 className="mt-4">Permissions</h4>
                <Table className="mt-2">
                  <thead className="">
                    <tr>
                      <th>Feature</th>
                      <th  className="pl-0 text-center">View</th>
                      <th className="pl-0 text-center">Add</th>
                      <th className="pl-0 text-center">Edit</th>
                      <th className="pl-0 text-center">Delete</th>
                    </tr>
                  </thead>
                  <tbody>
                    {features.map((feature, index) => (
                      <tr key={index}>
                        <td>{feature}</td>
                        <td  className=" text-center">
                          <Input
                            type="checkbox"
                            checked={subAdmin.permissions[handleFindSubAdminPrev(feature)].view}
                            onChange={() => handlePermissionChange(handleFindSubAdminPrev(feature), "view")}
                          />
                        </td>
                        <td className=" text-center">
                          <Input
                            type="checkbox"
                            checked={subAdmin.permissions[handleFindSubAdminPrev(feature)].add}
                            onChange={() => handlePermissionChange(handleFindSubAdminPrev(feature), "add")}
                          />
                        </td>
                        {/* {console.log(subAdmin.permissions)} */}
                        <td className=" text-center">
                          <Input
                            type="checkbox"
                            checked={subAdmin.permissions[handleFindSubAdminPrev(feature)].edit}
                            onChange={() => handlePermissionChange(handleFindSubAdminPrev(feature), "edit")}
                          />
                        </td>
                         <td className=" text-center">
                          <Input
                            type="checkbox"
                            checked={subAdmin.permissions[handleFindSubAdminPrev(feature)].delete}
                            onChange={() => handlePermissionChange(handleFindSubAdminPrev(feature), "delete")}
                          />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
                <div className="d-flex justify-content-between">
                  <BackButton title='Back'/>
                  <AddButton type='submit' title={id ? "Save Changes" : "Add Admin"}/>
                </div>
              </Form>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default AddEditSubAdmin;
